export enum EIdentityInfoType {
    passport = 'passport',
    identityCard = 'identityCard',
    secureFlightPassengerData = 'secureFlightPassengerData',
}

export const  IDENTITY_DOCUMENT_EDITOR_PERMISSION: string = 'shared.identityDocument.edit';
